import { useEffect, useState } from "react";
import { History } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import api from "@/lib/api";

const ACTION_LABELS = {
  created: "SOP créée",
  updated: "SOP modifiée",
  deleted: "SOP supprimée",
};

export default function SopHistoryDialog({ sopId }) {
  const [open, setOpen] = useState(false);
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    api
      .get(`/sops/${sopId}/history`)
      .then((res) => setEntries(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [open, sopId]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" data-testid="open-sop-history-button">
          <History className="h-4 w-4" />
          Historique
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto" data-testid="sop-history-dialog">
        <DialogHeader>
          <DialogTitle>Historique des modifications</DialogTitle>
          <DialogDescription>Toutes les modifications apportées à cette SOP.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          {loading && <p className="text-sm text-muted-foreground text-center py-6">Chargement...</p>}
          {!loading && entries.length === 0 && (
            <p className="text-sm text-muted-foreground text-center py-6" data-testid="sop-history-empty">
              Aucun historique disponible pour cette SOP.
            </p>
          )}
          {entries.map((e) => (
            <div key={e.id} className="border border-border rounded-md p-3 text-sm" data-testid={`sop-history-entry-${e.id}`}>
              <div className="flex items-center justify-between gap-2 mb-1">
                <Badge variant="secondary" className="text-[10px]">
                  {ACTION_LABELS[e.action] || e.action}
                </Badge>
                <span className="text-xs text-muted-foreground">
                  {new Date(e.timestamp).toLocaleString("fr-FR")}
                </span>
              </div>
              <p className="text-foreground">{e.summary}</p>
              <p className="text-xs text-muted-foreground mt-1">
                Par {e.actor_name || e.actor_email} ({e.actor_email})
              </p>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
